import type { ReactNode } from 'react';
import { cn } from '@/shared/lib';

interface ChipBaseProps {
  children: ReactNode;
  className?: string;
}

/** Чип количества у заголовка реестра (README §3): 22, padding 0 8, radius 11, surface-sunken, 12 500 ink-600. */
export function CountChip({ children, className }: ChipBaseProps) {
  return (
    <span
      className={cn(
        'inline-flex h-22 shrink-0 items-center rounded-11 bg-surface-sunken px-8 text-[12px] font-medium text-ink-600 tabular',
        className,
      )}
    >
      {children}
    </span>
  );
}

/** Бейдж пункта меню (README §1): min-width 18, высота 16, radius 18, wine-bordeaux, белый 10/16 600. */
export function Badge({ children, className }: ChipBaseProps) {
  return (
    <span
      className={cn(
        'inline-block h-16 min-w-18 shrink-0 rounded-18 bg-wine-bordeaux px-5 text-center text-[10px] leading-[16px] font-semibold text-ink-inverse-pure tabular',
        className,
      )}
    >
      {children}
    </span>
  );
}

/** Чип-значение (прототип, список значений в карточке): 24, padding 0 10, radius 12, кольцо line-hair. */
export function Chip({ children, className }: ChipBaseProps) {
  return (
    <span
      className={cn(
        'inline-flex h-24 items-center rounded-12 bg-paper-pure px-10 text-[12px] font-medium text-ink-900 shadow-[inset_0_0_0_1px_var(--vw-line-hair)]',
        className,
      )}
    >
      {children}
    </span>
  );
}
